import React from "react";

function Navbar() {
  return (
    <div>
      <nav className="navbar bg-dark">
        <div className="container-fluid">
          <a className="navbar-brand text-white" href="/">
            WeatherSoup🥣🌤️
          </a>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
